<template>
    <div v-if="company">
        <div class="columns toolbar-box action-right">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>{{ company.name }}</span>
                </h1>
            </div>
            <div class="column is-9 action-box">
                <div class="field is-grouped is-grouped-right is-flex-wrap">
                    <p class="control">
                        <router-link :to="backlink({name: 'companies.index'})" class="button is-info" >Back</router-link>
                    </p>
                    <p class="control">
                        <a @click.prevent="isProposalsModalActive = true" class="button is-info">Proposals</a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'proposals.create', query: { company_id: company.id } }" class="button is-success">Create Proposal</router-link>
                    </p>
                    <p class="control">
                        <a @click.prevent="isProjectsModalActive = true" class="button is-info">Projects</a>
                    </p>
                    <p class="control">
                        <a @click.prevent="openContactModal({company_id: company.id})" class="button is-info"><span class="icon"><i class="icm-new"></i></span><span>Add Contact</span></a>
                    </p>
                    <p class="control">
                        <a @click.prevent="handleRemove" class="button is-danger">Delete</a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'companies.edit', params: { slug: company.id } }" class="button is-info">Edit</router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns full-width is-multiline">
            <div class="column is-12 is-3-hd is-3-hd-wide is-3-hd-plus">
                <b-panel :collapsible="true">
                  <template #header>
                    <strong>Info</strong>
                  </template>
                    <div class="content full-width">
                        <div class="columns is-multiline">
                            <div class="column is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                                <p class="between-center"><strong>Name:</strong> <span>{{ $filters.valueOrDefault(company.name) }}</span></p>
                                <p class="between-center"><strong>Email:</strong> <span>{{ $filters.valueOrDefault(company.email) }}</span></p>
                                <p class="between-center"><strong>City:</strong> <span>{{ $filters.valueOrDefault(company.city) }}</span></p>
                                <p class="between-center"><strong>State:</strong> <span>{{ $filters.valueOrDefault(company.state) }}</span></p>
                                <p class="between-center"><strong>Zip:</strong> <span>{{ $filters.valueOrDefault(company.zip) }}</span></p>
                            </div>
                            <div class="column is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                                <p class="between-center"><strong>Telephone:</strong> <span>{{ $filters.valueOrDefault(company.phone) }}</span></p>
                                <p class="between-center"><strong>Fax:</strong> <span>{{ $filters.valueOrDefault(company.fax) }}</span></p>
                                <p class="between-center"><strong>Lead Owner:</strong> <span>{{ userNameById($filters.valueOrDefault(company.lead_owner)) }}</span></p>
                                <p class="between-center"><strong>Task Based:</strong> <span>{{ $filters.valueOrDefault(company.task_based) }}</span></p>
                                <p class="between-center"><strong>Tax ID:</strong> <span>{{ $filters.valueOrDefault(company.tax_id) }}</span></p>
                                <p class="between-center"><strong>IBM Number:</strong> <span>{{ $filters.valueOrDefault(company.ibm_number) }}</span></p>
                                <p class="between-center"><strong>DOB Tracking ID:</strong> <span>{{ $filters.valueOrDefault(company.ibm_exp_date) }}</span></p>
                            </div>
                            <div class="column is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                                <p class="between-center"><strong>HIC License:</strong> <span>{{ $filters.valueOrDefault(company.hic_license) }}</span></p>
                                <p class="between-center"><strong>DOB Tracking:</strong> <span>{{ $filters.valueOrDefault(company.dob_tracking) }}</span></p>
                                <p class="between-center"><strong>DOB Tracking Exp Date:</strong> <span>{{ $filters.valueOrDefault(company.dob_tracking_exp_date) }}</span></p>
                                <p class="between-center"><strong>Special Inspection Agency:</strong> <span>{{ $filters.valueOrDefault(company.special_inspection_agency) }}</span></p>
                            </div>
                        </div>
                    </div>
                </b-panel>
                <b-panel :collapsible="true">
                  <template #header>
                    <strong>Proposals Info</strong>
                  </template>
                    <div class="content full-width">
                        <div class="columns is-multiline">
                            <div v-if="stats !== null" class="column is-12-tables is-4-desktop is-4-widescreen is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                                <p class="between-center"><strong>Proposals:</strong><span>{{ stats.number }}</span></p>
                                <p class="between-center"><strong>Proposals Sent:</strong><span>{{ stats.sent }}</span></p>
                                <p class="between-center"><strong>Proposals Converted:</strong><span>{{ stats.converted }}</span></p>
                                <p class="between-center"><strong>Conversion Rate:</strong><span>{{ stats.conversion_rate }}%</span></p>
                                <p class="between-center"><strong>Total Value:</strong><span>{{ $filters.currency(stats.value ) }}</span></p>
                            </div>
                        </div>
                    </div>
                </b-panel>
                <b-panel v-if="company.notes" :collapsible="true">
                  <template #header>
                    <strong>Notes</strong>
                  </template>
                    <div class="content full-width">
                        <div class="columns is-multiline">
                            <div v-html="company.notes" class="column is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus"></div>
                        </div>
                    </div>
                </b-panel>
            </div>
            <contacts :reference-id="parseInt($route.params.slug)" reference-type="company"/>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactModalActive" has-modal-card>
            <contact-modal :edit-mode="true" :item="currentContact"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isProjectsModalActive" has-modal-card>
            <projects-modal :company-id="company.id"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isProposalsModalActive" has-modal-card>
            <proposals-modal :company-id="company.id"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
import ContactModal from '../../components/modals/Contact'
import ProjectsModal from '../../components/modals/Projects'
import ProposalsModal from '../../components/modals/Proposals'
import Table from '../../mixins/Table'
import HasBacklink from './../../mixins/Backlink'
import Contacts from './show/Contacts'

    export default {
        mixins: [Table, HasBacklink],

        components: {
            Contacts,
            ContactModal,
            ProjectsModal,
            ProposalsModal
        },

        created() {
            let id = this.$route.params.slug

            this.fetchCompanyById(id)
                .then(response => this.company = response.data.data)

            axios.get(`/api/companies/${id}/stats`)
                .then(res => {
                    this.stats = res.data.data
                })
        },

        data () {
            return {
                company: null,
                currentContact: null,
                isContactModalActive: false,
                isProposalsModalActive: false,
                isProjectsModalActive: false,

                isStatsFetched: false,
                stats: null
            }
        },

        methods: {
            ...mapActions({
                fetchCompanyById: 'fetchCompanyById',
                removeItem: 'removeCompany'
            }),

            openContactModal (contact) {
                this.currentContact = contact
                this.isContactModalActive = true
            },

            handleRemove() {
                this.confirmCustomDelete(
                    this.company,
                    'companies.index',
                    'Deleting Company',
                    'Are you sure you want to <strong>delete</strong> this company? This action cannot be undone.',
                    'Delete Company'

                )
            }
        },

        computed: {
            ...mapGetters({
                userNameById: 'userNameById'
            }),
        },
    }
</script>
